import { render, staticRenderFns } from "./TableBlue.vue?vue&type=template&id=6cc36938&scoped=true&"
import script from "./TableBlue.vue?vue&type=script&lang=js&"
export * from "./TableBlue.vue?vue&type=script&lang=js&"
import style0 from "./TableBlue.vue?vue&type=style&index=0&id=6cc36938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc36938",
  null
  
)

export default component.exports